var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef } from 'react';
import { fetchStatus } from './api';
import { PULL_POLL_BACKOFF_FACTOR, PULL_POLL_INTERVAL_MS, PULL_POLL_MAX_DELAY_MS } from './constants';
export function usePullStatusPolling({ urls, running, onStatus }) {
    const onStatusRef = useRef(onStatus);
    onStatusRef.current = onStatus;
    useEffect(() => {
        if (!running)
            return undefined;
        let cancelled = false;
        let timer;
        let consecutiveErrors = 0;
        const schedule = (delay) => {
            timer = setTimeout(() => {
                void poll();
            }, delay);
        };
        const poll = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const status = yield fetchStatus(urls);
                if (cancelled)
                    return;
                consecutiveErrors = 0;
                onStatusRef.current(status);
                if (status.bulkPullRunning)
                    schedule(PULL_POLL_INTERVAL_MS);
            }
            catch (_a) {
                if (cancelled)
                    return;
                consecutiveErrors += 1;
                schedule(Math.min(PULL_POLL_INTERVAL_MS * PULL_POLL_BACKOFF_FACTOR ** consecutiveErrors, PULL_POLL_MAX_DELAY_MS));
            }
        });
        schedule(PULL_POLL_INTERVAL_MS);
        return () => {
            cancelled = true;
            if (timer)
                clearTimeout(timer);
        };
    }, [running, urls]);
}
